define(["jquery"], function ($) {
    var toggleBlock = {
        WRAPPER_SELECTOR: ".toggleblock-wrapper",
        BUTTON_SELECTOR: ".js-toggle-element-two",
        ACTIVE_SELECTOR: ".active.js-toggle-element-two",
        POINTER_SELECTOR: ".toggle-switch--pointer",

        init: function () {
            var self = this;

            // Initialize each toggle block
            $(self.WRAPPER_SELECTOR).each(function () {
                var $wrapper = $(this);
                var $buttons = $wrapper.find(self.BUTTON_SELECTOR);

                // Bind click -> activate
                $buttons.on("click", function () {
                    var tabId = this.id.replace("-tab", "");
                    self.activateTab(tabId);
                });

                // Set initial pointer position (on first active tab)
                var $active = $wrapper.find(self.ACTIVE_SELECTOR);
                if ($active.length) {
                    self.activateTab($active.attr("id").replace("-tab", ""), false);
                }
            });

            // Handle initial hash on load
            self.handleHash();

            // Hash navigation
            $(window).on("hashchange", function () {
                self.handleHash();
            });

            // 🔑 Accordion toggle support (native event, not jQuery)
            document.addEventListener(
                "toggle",
                function (e) {
                    var el = e.target;
                    var parent = el.parentElement;
                    if (
                        el.tagName === "DETAILS" &&
                        el.id &&
                        !el.open &&
                        window.location.hash === "#" + el.id &&
                        parent.getAttribute("role") === "tabpanel"
                    ) {
                        var tabId = self.getActiveTabId();
                        if (tabId) {
                            history.replaceState(null, "", "#" + tabId);
                        } else {
                            history.replaceState(
                                null,
                                "",
                                window.location.pathname + window.location.search
                            );
                        }
                    }
                },
                true
            );
        },

        getTab: function (id) {
            return document.getElementById(id + "-tab");
        },

        getPanel: function (id) {
            return document.getElementById(id + "-panel");
        },

        activateTab: function (tabId, updateHash) {
            if (updateHash === undefined) updateHash = true;

            var self = this;
            var tab = self.getTab(tabId);
            var panel = self.getPanel(tabId);
            if (!tab || !panel) return;

            var $wrapper = $(tab).closest(self.WRAPPER_SELECTOR);
            if (!$wrapper.length) return;

            var $buttons = $wrapper.find(self.BUTTON_SELECTOR);
            var $panels = $wrapper.find('[role="tabpanel"]');

            // Reset all
            $buttons.removeClass("active").attr("aria-selected", "false");
            $panels.css("display", "none");

            // Activate selected
            $(tab).addClass("active").attr("aria-selected", "true");
            $(panel).css("display", "");

            // Move pointer
            var $pointer = $wrapper.find(self.POINTER_SELECTOR);
            if ($pointer.length) {
                $pointer.css({
                    width: $(tab).outerWidth() + "px",
                    left: $(tab).position().left + "px"
                });
            }

            // Update hash in URL
            if (updateHash) {
                history.replaceState(null, "", "#" + tabId);
            }
        },

        getActiveTabId: function () {
            var self = this;
            var $activeTab = $(self.BUTTON_SELECTOR + ".active").first();
            return $activeTab.length ? $activeTab.attr("id").replace("-tab", "") : null;
        },

        handleHash: function () {
            var self = this;
            var hash = window.location.hash.replace("#", "");
            if (!hash) return;

            var $element = $("#" + hash);

            if ($element.length) {
                // Case 1: Hash is a tab button id
                if ($element.attr("role") === "tab") {
                    var tabId = $element.attr("id").replace("-tab", "");
                    self.activateTab(tabId, false);
                    $element[0].scrollIntoView({ behavior: "smooth" });
                    return;
                }

                // Case 2: Hash is a panel id
                if ($element.attr("role") === "tabpanel") {
                    var tabId2 = $element.attr("id").replace("-panel", "");
                    self.activateTab(tabId2, false);
                    $element[0].scrollIntoView({ behavior: "smooth" });
                    return;
                }

                // Case 3: Hash is inside a tab panel
                var $wrapper = $element.closest(self.WRAPPER_SELECTOR);
                if ($wrapper.length) {
                    var $foundPanel = $wrapper.find('[role="tabpanel"]').filter(function () {
                        return $.contains(this, $element[0]);
                    });
                    if ($foundPanel.length) {
                        var tabId3 = $foundPanel.attr("id").replace("-panel", "");
                        self.activateTab(tabId3, false);
                    }
                }

                if ($element.prop("tagName") === "DETAILS" && !$element.prop("open")) {
                    $element.prop("open", true);
                }

                setTimeout(function () {
                    $element[0].scrollIntoView({ behavior: "smooth" });
                }, 100);
            } else {
                // Case 4: Hash is directly the tabId
                var tab = self.getTab(hash);
                if (tab) {
                    self.activateTab(hash, false);
                    tab.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    };

    return toggleBlock;
});
